export default price => {
  return price.toFixed(2).replace('.', ',')
}
